import { render, staticRenderFns } from "./ZoomEduSell.vue?vue&type=template&id=0a25ef3c&scoped=true&"
import script from "./ZoomEduSell.vue?vue&type=script&lang=js&"
export * from "./ZoomEduSell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a25ef3c",
  null
  
)

export default component.exports